import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, computed } from '../../adapter-vue';
import { isApp, isPC } from '../../utils/env';

interface IProps {
  file: string;
  size?: string;
  width?: string;
  height?: string;
  hotAreaSize?: number | string;
  tooltipText?: string;
}

interface IEmits {
  (key: 'onClick', e: Event): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
    file: { default: '' },
    size: null,
    width: { default: '20px' },
    height: { default: '20px' },
    hotAreaSize: null,
    tooltipText: null
  },
  emits: ["onClick"],
  setup(__props: any, { emit: emits }: { emit: ({
  (key: 'onClick', e: Event): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { file: string, size?: string, width: string, height: string, hotAreaSize?: number | string, tooltipText?: string }




const iconHotAreaSize = computed<undefined | string>(() => {
  if (!props.hotAreaSize) {
    return undefined;
  }
  if (isNaN(Number(props.hotAreaSize))) {
    return String(props.hotAreaSize);
  }
  return `${props.hotAreaSize}px`;
});

const iconWidth = computed(() => {
  return props.size ? props.size : props.width;
});

const iconHeight = computed(() => {
  return props.size ? props.size : props.height;
});

const handleImgClick = (e: Event) => {
  emits('onClick', e);
};

return { __sfc: true,emits, props, iconHotAreaSize, iconWidth, iconHeight, handleImgClick, isPC }
}

})